import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const PlusIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.0999 8.09998H9.90002V0.899942C9.90002 0.403252 9.49677 0 8.99992 0C8.50323 0 8.09998 0.403252 8.09998 0.899942V8.09998H0.899942C0.403252 8.09998 0 8.50323 0 8.99992C0 9.49677 0.403252 9.90002 0.899942 9.90002H8.09998V17.0999C8.09998 17.5967 8.50323 18 8.99992 18C9.49677 18 9.90002 17.5967 9.90002 17.0999V9.90002H17.0999C17.5967 9.90002 18 9.49677 18 8.99992C18 8.50323 17.5967 8.09998 17.0999 8.09998Z"
        fill="currentColor"
      />
    </svg>
  )
})

PlusIcon.displayName = 'PlusIcon'
